<template>
    <ul class="homepage-categories-list">
        <template v-for="item in list">
            <DropDownItem
                v-if="item.list"
                :key="item.symbol"
                :class="[`homepage-categories-list__item--${item.symbol}`]"
                class="homepage-categories-list__item"
                @toggleVisibleState="({ state }) => toggleVisibleStateInList({ state, symbol: item.symbol})"
            >
                <template>
                    <span
                        slot="default"
                        class="homepage-categories-list__label"
                    >
                        {{ item.name }}
                    </span>
                    <Component
                        :is="contentComponent"
                        v-if="visibleStateList.indexOf(item.symbol) >= 0"
                        slot="content"
                        v-bind="item"
                        :content-component="contentComponent"
                    />
                </template>
            </DropDownItem>
            <li
                v-else
                :key="item.symbol"
                class="homepage-categories-list__item"
                :class="[`homepage-categories-list__item--${item.symbol}`]"
            >
                <NuxtLink
                    :to="item.url.replace(baseUrl, '')"
                    :title="item.name"
                    class="homepage-categories-list__label"
                >
                    {{ item.name }}
                </NuxtLink>
            </li>
        </template>
    </ul>
</template>

<script>
import DropDownItem from '~/components/common/DropDownItem';
import BaseLink from '~/components/common/Link/BaseLink';

export default {
    name: 'SingleLevel',
    components: { BaseLink, DropDownItem },
    props: {
        list: {
            type: Array,
            default: () => {
            },
        },
        contentComponent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            baseUrl: process.env.baseUrl,
            visibleStateList: [],
        };
    },
    methods: {
        toggleVisibleStateInList({ state, symbol }) {
            if (state) {
                this.visibleStateList.push(symbol);
            } else {
                const symbolIndexInStateList = this.visibleStateList.indexOf(symbol);
                if (symbolIndexInStateList >= 0) {
                    this.visibleStateList.splice(symbolIndexInStateList, 1);
                }
            }
        },
    },
};
</script>

<style lang="scss">
    .homepage-categories-list {
        width: 100%;
        background: $color-castoBlue;

        &__item.active > button::after {
            transform: rotate(-180deg);
        }

        & > &__item {
            width: 100%;
            padding: 0;
            margin: 0;

            + .homepage-categories-list__item {
                border-top: solid 1px $color-castoBlue;
            }

            button, a {
                overflow: hidden;
                position: relative;
                width: 100%;
                display: inline-block;
                padding: 11px 10px 11px 10px;
                font: $font-weight-regular 16px/26px $goodHomeFontFamily;
                cursor: pointer;
                text-align: left;
                color: $color-castoWhite;
                text-decoration: none;
            }

            button::after {
                position: absolute;
                width: 20px;
                height: 100%;
                display: inline-block;
                content: ' ';
                right: 10px;
                top: 0;
                background-size: 100% auto;
                background: url('~static/images/svg/arrow-down-white.svg') center center no-repeat;
                transition: transform 0.1s ease-in;
                cursor: pointer;
            }
        }

        &__label {
            display: inline-block;
        }

        &__wrapper {
            width: 100%;
        }

        &__title {
            width: 100%;
            padding: 30px 10px 16px;
            font: $font-weight-bold 20px/22px $goodHomeFontFamily;
            color: $color-castoBlue;
        }

        .homepage-categories-list {
            background: $color-castoWhite;

            .homepage-categories-list__item {
                + .homepage-categories-list__item {
                    border-top-color: $color-slate10;
                }

                button, a {
                    color: $color-slate100;
                    text-decoration: none;
                    padding-left: 40px;
                }

                button::after {
                    background-image: url('~static/images/svg/arrow-down-gray.svg');
                }
            }

            .homepage-categories-list {
                background: $color-slate10;

                .homepage-categories-list__item {
                    + .homepage-categories-list__item {
                        border-top-color: $color-slate10;
                    }
                }

                button, a {
                    padding-left: 50px;
                }
            }
        }
    }
</style>
